import { env } from '@/config/env';
import type { MenuPermissionsMap } from '@/features/auth/types/auth.types';
import { useGetMyMenuPolicyQuery } from '@/features/menus/api/menusApi';
import { useAppSelector } from '@/hooks/useAppSelector';

/**
 * Map quyền menu/feature từ `GET /api/menus/me` → `data.features` (cùng shape {@link MenuPermissionsMap}).
 * Trước đây có thể dùng `GET /api/auth/permissions/me` — hiện lấy từ policy gateway.
 */
export function useEffectiveMenuPermissions(): {
  data: MenuPermissionsMap | undefined;
  isLoading: boolean;
  isError: boolean;
} {
  const user = useAppSelector((s) => s.auth.user);
  const skip = !user || !env.API_BASE_URL;
  const { data, isLoading, isError } = useGetMyMenuPolicyQuery(undefined, { skip });

  return {
    data: data?.features,
    isLoading,
    isError,
  };
}
